<script type="application/javascript">
import { url } from "@/profile/composables/url";
import axios from "axios";

export default {
  name: "PayComponent",
  props: ["pays", "to_pay", "email", "invoices", "project_visible", "project_state", "project_id", "contract_id", "autopay_data", "po", "pr"],
  data: function() {
    let ad;
    if (this.autopay_data == undefined) {
      ad = true;
    } else {
      ad = false;
    }
    return {
      autopay: this.pr === "ic", // Только для Индив. выбор
      sum: 0,
      pays_to_change: this.pays,
      mail: this.email,
      project_url: false,
      alert: "",
      added_invoices: [],
      show_autopay: ad,
      show_help_cancel: false,
      show_help_change: false
    };
  },
  methods: {
    send(params) {
      axios
        .post(url, {
          params: params
        });
    },
    changeprojectvisible2: function() {
      this.$emit("changeprojectvisible2");
    },
    changeSum: function(i) {
      // console.log(this.pays_to_change)
      for (let k in this.pays_to_change) {
        if (!this.pays_to_change[i].check) {
          this.pays_to_change[k].check = k <= i;
        } else {
          this.pays_to_change[k].check = k < i;
        }
      }
      this.sum = 0;
      for (let k in this.pays_to_change) {
        if (this.pays_to_change[k].check) {
          if (this.project_visible == 0) {
            this.sum = Number(this.pays_to_change[k].to_pay);
          } else {
            this.sum = Number(this.pays_to_change[k].to_pay_p);
          }
        }
      }
      this.$forceUpdate();
    },
    linkClick() {
      this.project_url = 1;
      let params = {
        command: "get_project_pdf",
        project_id: this.project_id,
        token: this.$route.params.token ? this.$route.params.token : this.$myApp.token.get()
      };
      let $this = this;
      axios.post(url, { params: params })
        .then(function(response) {
          let data = response.data;
          if (data.state === "ERR") {
            $this.errors = [];
            $this.errors.push(data.msg_text);
          }
          if (data.state === "OK") {
            $this.project_url = data.url;
            window.open(data.url, "_blank");
          }
        });
      setTimeout(function() {
        this.project_url = false;
      }, 120000);
    },
    getInvoice() {
      if (this.invoices.length > 2) {
        this.alert = "<div class=\"alert alert-danger\">Доступно не более трех действующих счетов</div>";
        return;
      }
      let reg = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;
      if (this.mail == "" || this.mail == null) {
        this.alert = "<div class=\"alert alert-danger\">Необходимо заполнить поле E-mail</div>";
        return;
      }
      if (reg.test(this.mail) === false) {
        this.alert = "<div class=\"alert alert-danger\">Не корректно заполнено поле E-mail</div>";
        return;
      }
      let params;
      if (this.autopay) {
        params = {
          command: "get_invoice",
          amount: this.sum,
          email: this.mail,
          contract_id: this.$route.params.token ? this.$route.params.id : this.contract_id,
          autopay: true,
          token: this.$route.params.token ? this.$route.params.token : this.$myApp.token.get()
        };
      } else {
        params = {
          command: "get_invoice",
          amount: this.sum,
          email: this.mail,
          contract_id: this.$route.params.token ? this.$route.params.id : this.contract_id,
          token: this.$route.params.token ? this.$route.params.token : this.$myApp.token.get()
        };
      }

      let $this = this;
      axios
        .post(url, {
          params: params
        })
        .then(function(response) {
          let data = response.data;
          // console.log(data);
          if (data.state == "ERR") {
            if (data.msg_text == "Токен не указан") {
              location.reload();
            }
            let res = data.detailed ? "".concat(data.msg_text, ": ", data.detailed) : data.msg_text;
            $this.alert = "<div class=\"alert alert-danger\">" + res + "</div>";
          }
          if (data.state == "OK") {
            $this.alert = "<div class=\"alert alert-success\">" + data.msg + "</div>";
            let i = data.invoice.split("/");
            let returned = {
              name: "Счет " + i[i.length - 2] + " на " + $this.sum + " действует сутки",
              url: data.invoice,
              qr_code: data.qr_code,
              qr_link: data.qr_link,
              type: data.type
            };
            $this.added_invoices.push(returned);
            // window.open(data.invoice, '_blank');
          }
        });
    },
    cancelCard() {
      let params = {
        command: "cancel_card",
        contract_id: this.$route.params.token ? this.$route.params.id : this.contract_id,
        token: this.$route.params.token ? this.$route.params.token : this.$myApp.token.get()
      };

      let $this = this;
      axios
        .post(url, {
          params: params
        })
        .then(function(response) {
          let data = response.data;
          // console.log(data);
          if (data.state == "ERR") {
            // console.log(data);
          }
          if (data.state == "OK") {
            $this.show_autopay = true;
            $this.show_help_cancel = false;
          }
        });
    },
    changeCard() {
      this.show_autopay = true;
      this.autopay = true;
      this.show_help_change = false;
    }
  },
  computed: {
    needAutoPay() { // Нужно ли отображать блок подключения автоплатежа
      if (this.pr === "ic") { // Только для Индив. выбор
        return true;
      } else {
        return false;
      }
    },
    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i
        .test(navigator.userAgent)) {
        return true;
      } else return false;
    },
    b2bframe() {
      if (this.$route.params.token) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<template>
  <div class="accardion-content accardion-content-active">
    <div class="policy-accardion-items-header">
      <div class="policy-accardion-items-title" style="width: 20%;">Дата по графику платежей</div>
      <div class="policy-accardion-items-title" style="width: 15%;">Сумма взноса</div>
      <div class="policy-accardion-items-title" style="width: 20%;">Фактическая дата оплаты</div>
      <div class="policy-accardion-items-title" style="width: 15%;">Оплачено</div>
      <div class="policy-accardion-items-title" style="width: 15%;">Статус платежа</div>
      <div class="policy-accardion-items-title" style="width: 10%;">Чек</div>
    </div>
    <div v-for="(pay, i) in pays_to_change" :key="i" class="policy-accardion-items">
      <div class="policy-accardion-items-text" style="width: 20%;">{{ pay.date }}</div>
      <div v-if="typeof pay.amount_p === 'undefined' || !project_visible" class="policy-accardion-items-text"
           style="width: 15%;">{{ pay.amount }}
      </div>
      <div v-if="typeof pay.amount_p !== 'undefined' && project_visible" class="policy-accardion-items-text"
           style="width: 15%;">{{ pay.amount_p }}
      </div>
      <div class="policy-accardion-items-text" style="width: 20%;">{{ pay.opl_date }}</div>
      <div v-if="typeof pay.amount_p === 'undefined' || !project_visible" class="policy-accardion-items-text"
           style="width: 15%;">{{ pay.opl }}
      </div>
      <div v-if="typeof pay.amount_p !== 'undefined' && project_visible" class="policy-accardion-items-text"
           style="width: 15%;">{{ pay.opl_p }}
      </div>
      <div v-if="typeof pay.amount_p === 'undefined' || !project_visible" class="policy-accardion-items-text"
           style="width: 15%;">{{ pay.status }}
      </div>
      <div v-if="typeof pay.amount_p !== 'undefined' && project_visible" class="policy-accardion-items-text"
           style="width: 15%;">{{ pay.status_p }}
      </div>
      <div v-if="!b2bframe" class="policy-accardion-items-text" style="width: 10%;">
      <span v-for="(row, key) in pay.receipt_url" :key="key">
          <a target="_blank" v-if="row !== null" :href="row">Скачать</a>
      </span>
      </div>

      <div class="policy-accardion-items-text" style="width: 3%;">
        <input v-if="pay.status !== 'Оплачен'" @click="changeSum(i)" type="checkbox" v-model="pay.check">
      </div>
    </div>
    <div v-if="to_pay">
      <div v-for="(invoice, key) in invoices" :key="key" class="pay-invoices">
        <div v-if="!autopay && invoice.type != 'tkb'">
          <p class="text-center">Счет {{ invoice.invoice }} на {{ invoice.amount }} действителен до {{ invoice.end
            }}</p>
          <div class="invoice-link-pay">
            <div class="invoice-card-pay">
              <a target="_blank" :href="invoice.url">Оплатить картой</a>
            </div>
            <div class="invoice-qr-pay" v-if="invoice.qr_code != undefined">
              <a v-if="!isMobile" target="_blank" :href="invoice.qr_link">
                <svg v-if="!isMobile" role="img" aria-label="qr_code" class="qr_code" viewBox="0 0 219 200"
                     width="128px" height="128px">
                  <g>
                    <image id="blink" x="15" y="0" :xlink:href="invoice.qr_code" />
                  </g>
                </svg>
              </a>
              <p v-if="!isMobile" class="qr-text">Оплата через СБП</p>
              <a class="invoice-mob" target="_blank" v-if="isMobile" :href="invoice.qr_link">Оплатить СБП(QR)</a>
            </div>
          </div>
        </div>
        <div v-if="autopay && invoice.type == 'tkb'">
          <p class="text-center">Счет {{ invoice.invoice }} на {{ invoice.amount }} действителен до {{ invoice.end
            }}</p>
          <div class="invoice-link-pay">
            <div class="invoice-card-pay">
              <a target="_blank" :href="invoice.url">Оплатить картой</a>
            </div>
            <div class="invoice-qr-pay">
              После оплаты картой будет подключено автоматическое списание
            </div>
          </div>
        </div>
      </div>
      <div v-if="added_invoices.length > 0">
        <div v-for="(invoice, key) in added_invoices" :key="key" class="pay-invoices">
          <div v-if="!autopay && invoice.type != 'tkb'">
            <p class="text-center">{{ invoice.name }}</p>
            <div class="invoice-link-pay">
              <div class="invoice-card-pay">
                <a target="_blank" :href="invoice.url">Оплатить картой</a>
              </div>
              <div class="invoice-qr-pay" v-if="invoice.qr_code != undefined">
                <a v-if="!isMobile" target="_blank" :href="invoice.qr_link">
                  <svg v-if="!isMobile" role="img" aria-label="qr_code" class="qr_code" viewBox="0 0 219 200"
                       width="128px" height="128px">
                    <g>
                      <image id="blink" x="15" y="0" :xlink:href="invoice.qr_code" />
                    </g>
                  </svg>
                </a>
                <p v-if="!isMobile" class="qr-text">Оплата через СБП</p>
                <a class="invoice-mob" v-if="isMobile" target="_blank" :href="invoice.qr_link">Оплатить СБП(QR)</a>
              </div>
            </div>
          </div>

          <div v-if="autopay && invoice.type == 'tkb'">
            <p class="text-center">{{ invoice.name }}</p>
            <div class="invoice-link-pay">
              <div class="invoice-card-pay">
                <a target="_blank" :href="invoice.url">Оплатить картой</a>
              </div>
              <div class="invoice-qr-pay">
                После оплаты картой будет подключено автоматическое списание
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pay-get-invoice-result" v-html="alert"></div>
      <div v-if="needAutoPay" class="autopay">
        <div v-if="!show_autopay" class="autopay-data">
          Подключена автоматическая оплата с карты {{ autopay_data.CARD_NUMBER }}, действительной до
          {{ autopay_data.CARD_EXP_MONTH }}/{{ autopay_data.CARD_EXP_YEAR }}
        </div>
        <div class="text-size-14" v-if="show_autopay">Подключая автоплатеж, принимаю условия <a
          href="https://makclife.ru/upload/medialibrary/806/%D0%A1%D0%BE%D0%B3%D0%BB%D0%B0%D1%88%D0%B5%D0%BD%D0%B8%D0%B5%D0%A0%D0%B5%D0%B3%D1%83%D0%BB%D1%8F%D1%80%D0%BD%D1%8B%D0%B5%D0%A1%D0%BF%D0%B8%D1%81%D0%B0%D0%BD%D0%B8%D1%8F.pdf"
          target="_blank"
        >Соглашения о проведении регулярных платежей</a></div>

        <input :disabled="po == 12" v-if="show_autopay" type="checkbox" name="autopay" v-model="autopay"> <span
        v-if="show_autopay">Подключить автоплатеж</span>
        <button class="cancelbtn" @click="show_help_cancel = !show_help_cancel" v-if="po != 12 && !show_autopay"
                type="button">Отключить карту
        </button>
        <button class="changebtn" v-if="!show_autopay" @click="show_help_change = !show_help_change" type="button">
          Изменить карту
        </button>
        <div v-if="show_help_cancel" class="autopay-help">Вы действительно хотите отключить карту?
          <button class="cancelbtn" type="button" @click="cancelCard">Да</button>
          <button class="cancelbtn greenbtn" type="button" @click="show_help_cancel = !show_help_cancel">Нет</button>
        </div>
        <div v-if="show_help_change" class="autopay-help">Вы действительно хотите изменить карту?
          <button class="changebtn" type="button" @click="changeCard">Да</button>
          <button class="changebtn greenbtn" type="button" @click="show_help_change = !show_help_change">Нет</button>
        </div>
        <div class="autopay-desc">Списание платежей будет осуществляться автоматически в соответствии с графиком
          платежей по договору.
        </div>
      </div>
      <div v-if="show_autopay" class="pay-title">
        <span>Укажите e-mail плательщика для получения чека об оплате</span>
      </div>
      <div v-if="show_autopay" class="input-text-container">
        <label class="form-label">
          <span class="input-title require">E-mail<span class="require-icon">*</span></span>
          <input type="text" placeholder="example@mail.com"
                 class="input invoice-email" v-model="mail">
        </label>
        <label class="form-label">
          <span style="font-size: 10pt" class="input-title require">Сумма взноса / очередных взносов к оплате<span
            class="require-icon">*</span></span>
          <input class="input invoice-amount" type="text" :value="sum" readonly="readonly" disabled="disabled">
        </label>
        <label>
          <input v-if="sum>0" type="button" @click="getInvoice" value="Сформировать счет"
                 class="common-button lightblue">
        </label>
      </div>
      <div style="font-size: 10pt; margin-top: 10px;" v-if="project_visible">
        Предлагаем увеличить размер итоговых накоплений и обеспечить их защиту от инфляции по Вашей программе с
        использованием инструмента индексации на условиях, изложенных в
        <a class="pdf-link" @click.prevent="linkClick">
          Уведомлении (Соглашение (Оферта))
        </a>.
        <span v-if="project_url" style="position: relative">
          <div
            style="position: absolute; padding: 0.5em; background: #ffffff; border: #0a0a0a;left:0;bottom: 0;box-shadow: 0.05em 0.05em 0.15em 0.15em #1f1f1f">
            <span v-if="project_url===1">Формируем ссылку</span>
            <a v-if="project_url!==1" style="font-size: 10pt; line-height: inherit;" :href="project_url"
               target="_blank">Скачать</a>.
          </div>
        </span>
        Осуществите оплату проиндексированного взноса, и размер Вашей страховой защиты автоматически увеличится. Оплата
        индексированного страхового взноса в размере и сроки, указанные в прилагаемых к уведомлению измененных условиях
        страхования, считается Вашим согласием с измененными с учетом индексации условиями страхования. В случае отказа
        от условий индексации нажмите на кнопку
        <a class="reject-link" @click.prevent="changeprojectvisible2()">
          отказаться
        </a>
        и оплатите сумму взноса на условиях, предусмотренных Вашим договором страхования.
      </div>
    </div>
  </div>
</template>
<style>

.alert {
  top: 0;
}

.autopay {
  border: 2px solid red;
  padding: 10px;
  margin-bottom: 15px;
}

.cancelbtn, .changebtn {
  padding: 5px;
  cursor: pointer;
  font: 640 16px SourceSansPro, sans-serif;
  border-radius: .3rem;
  -webkit-transition-duration: 0.4s; /* Safari */
  transition-duration: 0.4s;
  margin-right: 10px;
}

.cancelbtn {
  background: #cc0007;
  color: #FFFFFF;
  border: 2px solid #bb0108;
  outline: #cc0007;
}

.changebtn {
  background: #0062cc;
  color: #FFFFFF;
  border: 2px solid #005cbf;
  outline: #0075D4;
}

.changebtn:hover, .cancelbtn:hover {
  background-color: white;
  color: #000000;
}

.greenbtn {
  background: #47cc00;
  color: #FFFFFF;
  border: 2px solid #339a00;
  outline: #51e200;
}

.autopay-desc {
  font-size: 10pt;
}

.text-size-14 {
  font-size: 14pt;
}

.text-center {
  text-align: center;
}

.qr-text {
  text-align: center;
  font-size: 10pt;
}

.invoice-link-pay {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}

.invoice-card-pay {
  width: max-content;
}

.invoice-qr-pay {
  width: max-content;
}

.invoice-qr-pay a {
  margin: auto;
  display: block;
  width: fit-content;
  cursor: pointer;
  text-decoration: none;
}

.invoice-qr-pay a:hover {
  text-decoration: none;
  border-bottom: none !important;
}

.invoice-card-pay a, .invoice-qr-pay a.invoice-mob {
  padding: .7em;
  float: none;
  color: #fff !important;
  background: #004b88;
  font-size: 14pt;
  font-weight: 600;
  display: block;
  width: fit-content;
  text-decoration: none;
  margin: 15px auto auto;
  white-space: nowrap;
}

.invoice-card-pay a:hover, .invoice-qr-pay a.invoice-mob:hover {
  background: #008cff;
  color: #fff;
}

.pay-invoices {
  margin: 20px 0px;
}

.pdf-link {
  font-size: 10pt;
  line-height: inherit;
  color: #004b88;
  border-bottom: 1px solid #004b88;
}

.reject-link {
  display: inline-block;
  font-size: 10pt;
  line-height: inherit;
  color: #004b88;
  border-bottom: 1px solid #004b88;
}

.reject-link:hover, .pdf-link:hover {
  color: #008cff;
  border-bottom: 1px solid #008cff;
  cursor: pointer;
}

</style>